import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfileRouter,
  editProfileRouter,
  readProfileRouterByProfileId,
  removeProfileRouter,
} from "./thunkAction";

const initialState = {
  profileRouter: {},
  loading: false,
  error: null,
  isLoadingAddProfileRouter: false,
  addProfileRouterError: null,
};

const profileRouterSlice = createSlice({
  name: "profileRouterManage",
  initialState,
  reducers: {
    clearProfileRouter(state) {
      state.profileRouter = {};
    },
    setProfileRouter(state, action) {
      state.profileRouter = _.get(action, "payload", {});
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // readProfileRouterByProfileId
      .addCase(readProfileRouterByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(readProfileRouterByProfileId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.profileRouter = _.get(action, "payload", {});
      })
      .addCase(readProfileRouterByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addProfileRouter
      .addCase(addProfileRouter.pending, (state) => {
        state.isLoadingAddProfileRouter = true;
        state.addProfileRouterError = null;
      })
      .addCase(addProfileRouter.fulfilled, (state, action) => {
        state.isLoadingAddProfileRouter = false;
        state.profileRouter = _.get(action, "payload", {});
      })
      .addCase(addProfileRouter.rejected, (state, action) => {
        state.isLoadingAddProfileRouter = false;
        state.addProfileRouterError = action.payload;
      })
      // editProfileRouter
      .addCase(editProfileRouter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileRouter.fulfilled, (state, action) => {
        state.loading = false;
        state.profileRouter = _.get(action, "payload", {});
      })
      .addCase(editProfileRouter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfileRouter
      .addCase(removeProfileRouter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfileRouter.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeProfileRouter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileRouterReducer = profileRouterSlice.reducer;

export const profileRouterAction = profileRouterSlice.actions;
